import VueTypes, { nullable } from 'vue-types';

export const MenuSubcategoryItem = VueTypes.shape({
    id: VueTypes.number.isRequired,

    title: VueTypes.string.isRequired,
    url: VueTypes.string.isRequired,
    subcategories: VueTypes.array.def([])
}).isRequired;

export const MenuCategoryItem = VueTypes.shape({
    id: VueTypes.number.isRequired,

    title: VueTypes.string.isRequired,
    url: VueTypes.string.isRequired,
    image: VueTypes.string.isRequired,

    subcategories: VueTypes.arrayOf(MenuSubcategoryItem).def([])
}).isRequired;

export const createMenuSubcategoryItem = ({ id, title, url, subcategories = [] }) => {
    return {
        id: id,
        title: title,
        url: url,
        subcategories: subcategories
    };
};

export const createMenuCategoryItem = ({ id, title, url, image, subcategories = [] }) => {
    return {
        id: id,
        title: title,
        url: url,
        image: image,
        subcategories: subcategories
    };
};
